import { queryOptions, useQuery } from '@tanstack/react-query'
import { InferRequestType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type SearchDocumentsArgs = InferRequestType<
  typeof apiClient.documents.search.$post
>['json']

export const searchDocumentsQueryOptions = (args?: SearchDocumentsArgs) =>
  queryOptions({
    queryKey: ['documents-search', args],
    queryFn: () =>
      apiClient.documents.search
        .$post({ json: args })
        .then((r) => formatClientResponse(r)),
  })

export const useSearchDocuments = (
  args?: SearchDocumentsArgs,
  options?: Partial<ReturnType<typeof searchDocumentsQueryOptions>>
) =>
  useQuery({
    ...searchDocumentsQueryOptions(args),
    ...options,
  })
